import ScrollBar from './src/main'
import { addComponent } from '~/utils/helper'

//// https://www.npmjs.com/package/vue-scroll-bar

export default addComponent(ScrollBar)


// WEBPACK FOOTER //
// ./public/scroll-bar/index.js